var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<button id=\"btn-continue\" type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"$bbMoveBookingCtrl.checkBookingReadyToMove()\" bb-debounce ng-disabled=\"!$bbMoveBookingCtrl.booking.datetime === $bbMoveBookingCtrl.booking.srcBooking.datetime\">\n<span translate=\"PUBLIC_BOOKING.CALENDAR.MOVE_BOOKING_BTN\">>\n</span>\n</button>";
var id1="public-booking/move-booking/move_booking_button.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/move-booking/move_booking_button.html
// module id = 1231
// module chunks = 0